const search = {
  namespaced: true,
  state: {
    terms: '',
    prevTerms: '',
    results: [],
    populars: [],
    noResult: false,
    requests: 0,
    lawCase: null,
    mode: 'search'
  },
  mutations: {
    updateTerms(state, terms) {
      state.terms = terms;
    },
    updatePrevTerms(state, terms) {
      state.terms = terms;
    },
    updateResults(state, results) {
      state.results = results;
    },
    updateNoResult(state, flag) {
      state.noResult = flag;
    },
    updateRequests(state, type) {
      state.requests = type === 'dec' ? state.requests - 1 : state.requests + 1;
    },
    updateLawCase(state, lawCase) {
      state.lawCase = lawCase;
    },
    updateMode(state, mode) {
      state.mode = mode;
    }
  },
  actions: {
    // search(context) {
    async search({ rootState, state, dispatch, commit }) {
      commit('updateRequests');
      commit('updateNoResult', false);
      commit('updatePrevTerms', state.terms);

      const request = await dispatch('calls/search', { uuid: rootState.client.uuid, terms: state.terms }, { root: true });
      const { status, data } = request;

      if (status === 'success') {
        if (data.length === 0) {
          commit('updateNoResult', true);
        }

        commit('updateResults', data);
        commit('updateRequests', 'dec');
      }
    },
    async getLawcase({ dispatch, commit }, id) {
      commit('updateRequests');

      const request = await dispatch('calls/lawCase', id, { root: true });

      if (request.status === 'success') {
        commit('updateLawCase', request.data.data);
        commit('updateTerms', request.data.data.content);
      }

      commit('updateRequests', 'dec');
    }
  }
};


export default search;
